import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoneyBag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10 13.0833C9.61569 13.0833 9.29049 12.9479 9.02438 12.6771C8.75813 12.4062 8.625 12.0787 8.625 11.6944C8.625 11.3102 8.75813 10.9827 9.02438 10.7119C9.29049 10.441 9.61569 10.3056 10 10.3056C10.3935 10.3056 10.7256 10.441 10.9965 10.7119C11.2673 10.9827 11.4027 11.3102 11.4027 11.6944C11.4027 12.0787 11.2673 12.4062 10.9965 12.6771C10.7256 12.9479 10.3935 13.0833 10 13.0833ZM6.34021 5.90271H13.6875L15.3819 2.5H4.63188L6.34021 5.90271ZM6.94438 17.5H13.0694C14.3009 17.5 15.3495 17.0683 16.2152 16.2048C17.081 15.3415 17.514 14.2917 17.514 13.0556C17.5047 12.5278 17.412 12.0209 17.236 11.5348C17.0602 11.0487 16.8056 10.6042 16.4723 10.2015L14.0556 7.29167H5.95833L3.52771 10.2015C3.20368 10.6042 2.95139 11.0487 2.77083 11.5348C2.59028 12.0209 2.5 12.5278 2.5 13.0556C2.5 14.2917 2.93174 15.3415 3.79521 16.2048C4.65854 17.0683 5.70826 17.5 6.94438 17.5Z",
		fill: "#262626"
	})]
});
const ForwardRef = forwardRef(SvgMoneyBag);
export default ForwardRef;
